import React from 'react';
import ReactDOM from 'react-dom/client';
import './App.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { store } from './Store/store';
import { Provider } from 'react-redux';
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import ErrorPage from './Pages/ErrorPage';
import ProjectsPage from './Pages/ProjectsPage';
import Home from './Pages/Home';
import TrashPage from './Pages/TrashPage';
import FavoritePage from './Pages/FavoritePage';
import ProjectPage from './Pages/ProjectPage';
import ImagePage from './Pages/ImagePage';
import ResultPage from './Pages/ResultPage';
import ProfilePage from './Pages/ProfilePage';
import BillingPage from './Pages/BillingPage';
import Members from './Pages/Members';
import ProtectedRoute from './Components/ProtectedRoute';

// Initialize theme before app renders
const initializeTheme = () => {
  const savedTheme = localStorage.getItem('theme-preference') as 'light' | 'dark' | 'auto' | null;
  const html = document.documentElement;
  
  if (savedTheme === 'light') {
    html.classList.remove('dark');
    html.setAttribute('data-theme', 'light');
  } else if (savedTheme === 'dark') {
    html.classList.add('dark');
    html.setAttribute('data-theme', 'dark');
  } else {
    // Auto mode or no saved preference
    if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
      html.classList.add('dark');
      html.setAttribute('data-theme', 'dark');
    } else {
      html.classList.remove('dark');
      html.setAttribute('data-theme', 'light');
    }
  }
};

// Apply initial theme
initializeTheme();

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "/projects",
        element: <ProjectsPage />,
      },
      {
        path: "/projects/:projectId",
        element: <ProjectPage />,
      },
      {
        path: "/projects/:projectId/images/:imageId",
        element: <ImagePage />,
      },
      {
        path: "/projects/:projectId/images/:imageId/results/:resultId",
        element: <ResultPage />,
      },
      {
        path: "/projects/:projectId/images/:imageId/results/:resultId/compare/:compare",
        element: <ResultPage />,
      },
      {
        path: "/favorites",
        element: <FavoritePage />,
      },
      {
        path: "/trash",
        element: <TrashPage />,
      },
      {
        path: "/profile",
        element: <ProfilePage />,
      },
      {
        path: "/billing",
        element: <ProtectedRoute><BillingPage /></ProtectedRoute>,
      },
      {
        // Not wrapped in ProtectedRoute: that redirects away, and this page
        // renders its own explanation when team management isn't available.
        path: "/members",
        element: <Members />,
      }
    ],
  },
]);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <RouterProvider router={router} />
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
